export const MplusMapInformation = {
    venue: "M+",
    venueId: "M+",
    i18nVenue: "venue_m_plus",
    venueName: "M+",
    venueName_zh: "M+",
    floorAlignment: [
      {
        lcMapId: "35ad9534-c4f5-4ff8-95b7-de0ef2fceb64",
        id: "MP_TBC_-2",
        ordinal: -2,
        name: "B2",
        imageUrl:
          "https://locaite-dev.collectiv.co/assets/adec446e-8ad3-49a4-bd90-fed5f442ebbd/m0-1718707105983VIXIWU.png",
        pixInMeter: 20.747134679934007,
        center: { lat: 22.300853443913553, lng: 114.15912420169451 },
        angle: 356.2152582177846,
        scale: 48.19950495769161,
        corners: {
          tl: { lat: 22.301680646033, lng: 114.1581034463103 },
          tr: { lat: 22.30180328806959, lng: 114.1600131494735 },
          br: { lat: 22.30002624179411, lng: 114.1601449570787 },
          bl: { lat: 22.29990359975752, lng: 114.1582352539155 },
        },
        size: { width: 4096, height: 4096 },
        sizeInMeters: { width: 196.93818859815383, height: 198.06353462167613 },
      },
      {
        lcMapId: "0fa8b69c-0a18-497b-b385-c43f842f6b37",
        id: "MP_TBC_-1",
        ordinal: -1,
        name: "B1",
        imageUrl:
          "https://locaite-dev.collectiv.co/assets/adec446e-8ad3-49a4-bd90-fed5f442ebbd/m1-1718707206449JOWAMU.png",
        pixInMeter: 20.747209926992728,
        center: { lat: 22.300853443913574, lng: 114.15912420169445 },
        angle: 356.21525821784957,
        scale: 48.19933014557889,
        corners: {
          tl: { lat: 22.3016806430329, lng: 114.1581034500124 },
          tr: { lat: 22.30180328462469, lng: 114.1600131462494 },
          br: { lat: 22.30002624479425, lng: 114.1601449533765 },
          bl: { lat: 22.29990360320246, lng: 114.1582352571396 },
        },
        size: { width: 4096, height: 4096 },
        sizeInMeters: { width: 196.93747433814468, height: 198.06281627925895 },
      },
      {
        lcMapId: "c7d52241-fceb-408f-b6d5-a416895f315c",
        id: "MP_TBC_0",
        ordinal: 0,
        name: "L0",
        imageUrl:
          "https://locaite-dev.collectiv.co/assets/adec446e-8ad3-49a4-bd90-fed5f442ebbd/m2-1718707281081CEFOFU.png",
        pixInMeter: 20.747134679934007,
        center: { lat: 22.300853443913553, lng: 114.15912420169451 },
        angle: 356.2152582177846,
        scale: 48.19950495769161,
        corners: {
          tl: { lat: 22.301680646033, lng: 114.1581034463103 },
          tr: { lat: 22.30180328806959, lng: 114.1600131494735 },
          br: { lat: 22.30002624179411, lng: 114.1601449570787 },
          bl: { lat: 22.29990359975752, lng: 114.1582352539155 },
        },
        size: { width: 4096, height: 4096 },
        sizeInMeters: { width: 196.93818859815383, height: 198.06353462167613 },
      },
      {
        lcMapId: "72711871-3e59-44a9-a126-77220f0de95c",
        id: "MP_TBC_2",
        ordinal: 2,
        name: "L2",
        imageUrl:
          "https://locaite-dev.collectiv.co/assets/adec446e-8ad3-49a4-bd90-fed5f442ebbd/m3-1718707397491FUMEMA.png",
        pixInMeter: 20.747209926992728,
        center: { lat: 22.300853443913574, lng: 114.15912420169445 },
        angle: 356.21525821784957,
        scale: 48.19933014557889,
        corners: {
          tl: { lat: 22.3016806430329, lng: 114.1581034500124 },
          tr: { lat: 22.30180328462469, lng: 114.1600131462494 },
          br: { lat: 22.30002624479425, lng: 114.1601449533765 },
          bl: { lat: 22.29990360320246, lng: 114.1582352571396 },
        },
        size: { width: 4096, height: 4096 },
        sizeInMeters: { width: 196.93747433814468, height: 198.06281627925895 },
      },
      {
        lcMapId: "f8b6b844-7bd1-4d16-88c1-c84f50c5c9c1",
        id: "MP_TBC_3",
        ordinal: 3,
        name: "L3",
        imageUrl:
          "https://locaite-dev.collectiv.co/assets/adec446e-8ad3-49a4-bd90-fed5f442ebbd/m4-1718718813050WAJEDO.png",
        pixInMeter: 20.747209926992728,
        center: { lat: 22.300853443913574, lng: 114.15912420169445 },
        angle: 356.21525821784957,
        scale: 48.19933014557889,
        corners: {
          tl: { lat: 22.3016806430329, lng: 114.1581034500124 },
          tr: { lat: 22.30180328462469, lng: 114.1600131462494 },
          br: { lat: 22.30002624479425, lng: 114.1601449533765 },
          bl: { lat: 22.29990360320246, lng: 114.1582352571396 },
        },
        size: { width: 4096, height: 4096 },
        sizeInMeters: { width: 196.93747433814468, height: 198.06281627925895 },
      },
      {
        lcMapId: "d54a1d46-a635-4ab5-aaa1-45015e65ad68",
        id: "MP_TBC_11",
        ordinal: 11,
        name: "L11",
        imageUrl:
          "https://locaite-dev.collectiv.co/assets/adec446e-8ad3-49a4-bd90-fed5f442ebbd/m5-1718718856058JUPOGU.png",
        pixInMeter: 20.747209926992728,
        center: { lat: 22.300853443913574, lng: 114.15912420169445 },
        angle: 356.21525821784957,
        scale: 48.19933014557889,
        corners: {
          tl: { lat: 22.3016806430329, lng: 114.1581034500124 },
          tr: { lat: 22.30180328462469, lng: 114.1600131462494 },
          br: { lat: 22.30002624479425, lng: 114.1601449533765 },
          bl: { lat: 22.29990360320246, lng: 114.1582352571396 },
        },
        size: { width: 4096, height: 4096 },
        sizeInMeters: { width: 196.93747433814468, height: 198.06281627925895 },
      },
      {
        lcMapId: "04902764-e21f-4292-ad38-9685e3e47ad7",
        id: "MP_TBC_16",
        ordinal: 16,
        name: "L16",
        imageUrl:
          "https://locaite-dev.collectiv.co/assets/adec446e-8ad3-49a4-bd90-fed5f442ebbd/m6-1718718900330JATAYU.png",
        pixInMeter: 20.747134679934007,
        center: { lat: 22.300853443913553, lng: 114.15912420169451 },
        angle: 356.2152582177846,
        scale: 48.19950495769161,
        corners: {
          tl: { lat: 22.301680646033, lng: 114.1581034463103 },
          tr: { lat: 22.30180328806959, lng: 114.1600131494735 },
          br: { lat: 22.30002624179411, lng: 114.1601449570787 },
          bl: { lat: 22.29990359975752, lng: 114.1582352539155 },
        },
        size: { width: 4096, height: 4096 },
        sizeInMeters: { width: 196.93818859815383, height: 198.06353462167613 },
      },
    ],
    name: "L0",
    imageUrl:
      "https://locaite-dev.collectiv.co/assets/adec446e-8ad3-49a4-bd90-fed5f442ebbd/m2-1718707281081CEFOFU.png",
    pixInMeter: 20.747134679934007,
    center: { lat: 22.300853443913553, lng: 114.15912420169451 },
    angle: 356.2152582177846,
    scale: 48.19950495769161,
    corners: {
      tl: { lat: 22.301680646033, lng: 114.1581034463103 },
      tr: { lat: 22.30180328806959, lng: 114.1600131494735 },
      br: { lat: 22.30002624179411, lng: 114.1601449570787 },
      bl: { lat: 22.29990359975752, lng: 114.1582352539155 },
    },
    size: { width: 4096, height: 4096 },
    sizeInMeters: { width: 196.93818859815383, height: 198.06353462167613 },
    entry_mapId: 0,
  }